import RouteContainer from 'containers/RouteContainer';
import Component from './containers/RehabilitationContainer';

export const path = `${DOCUMENTS_PATH}/rehabilitation`;
export const navigation = { name: 'rehabilitation', id: 'rehabilitation.title' };

export default RouteContainer(path, Component);
